
// import { DatePicker } from 'antd';
import React, { useState, useEffect } from 'react'
// import Select from 'react-select'
import Axios from 'axios';
import { API_BASE_URL, GET_PAYMENTS_TYPES, GET_PO_RECEIVED_BY_ID, ADD_PAYMENTS } from '../../../Config';
import PropTypes from 'prop-types';
import Swal from "sweetalert2";
import Select from 'react-select'


const GenerateInvoicePayment = ({ INVObj }) => {
    
    const [userDataSession, setUserDataSession] = useState([]);
    // const [currentDate, setCurrentDate] = useState('');
    const [loading, setLoading] = useState(false);
    
    const [viewProducts, setViewProducts] = useState([]);
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [paidAmount, setPaidAmount] = useState("");
    const [paymentType, setSelectedPaymentType] = useState(null);
    const [paymentDate, setPaymentDate] = useState(null);
    const [totalAmount, setTotalAmount] = useState("");
    const [taxAmount, setTaxAmount] = useState("");
    const [mobile, setMobile] = useState("");
    const [cardNo, setCardNo] = useState("");
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

    // #region Session userdetails
    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
            
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);

    // #region Get Purchase req details
    useEffect(() => {
        if (userDataSession && userDataSession.OrgId && INVObj && INVObj.PurchaseId){
        setLoading(true);
          Axios.get(`${API_BASE_URL}${GET_PO_RECEIVED_BY_ID}?PurchaseId=${INVObj.PurchaseId}&UserId=${userDataSession.UserId}`)
            .then(response => {
                if (response.data.Status) {
                    setLoading(false);
                    setViewProducts(response.data.ResultData);
                    console.log(response.data.ResultData, 'po received by id data data..');
                } else {
                    setLoading(false);
                    console.error('Error fetching data:', response.data.Message);
                }
            })
            .catch(error => {
                setLoading(false);
                console.error('Error fetching data:', error);
            });

          Axios.get(`${API_BASE_URL}${GET_PAYMENTS_TYPES}?OrgId=${userDataSession.OrgId}`)
            .then(response => {
                if (response.data.Status) {
                    setLoading(false);
                    setPaymentTypes(response.data.ResultData);
                } else {
                    setLoading(false);
                    console.error('Error fetching data:', response.data.Message);
                }
            })
            .catch(error => {
                setLoading(false);
                console.error('Error fetching data:', error);
            });
        }
    
    }, [userDataSession, INVObj]);

    useEffect(() => {
        let totalTaxAmt = 0;
        let totalAmount = 0;
    
        if (viewProducts && viewProducts.length > 0) {
    
            totalTaxAmt = viewProducts.reduce((acc, product) => {
                const taxRate = product.CGSTRate + product.SGSTRate;
                const taxAmount = (product.UnitPrice * product.Quantity * taxRate) / 100;
                return acc + (taxAmount || 0);
            }, 0);
    
            totalAmount = viewProducts.reduce((acc, product) => {
                const amount = product.UnitPrice * product.Quantity;
                return acc + (amount || 0);
            }, 0);
        }
    
        setTaxAmount(totalTaxAmt);
        setTotalAmount((totalAmount + totalTaxAmt) - (INVObj?.DiscountAmount)); 
    }, [viewProducts]);  

    const handlePaidAmountChange = (e) => {
        setPaidAmount(e.target.value);
     };

    const handlePaymentTypeChange = (selectedOption) => {
        setSelectedPaymentType(selectedOption.value);
    };

    const handlePaymentDateChange = (e) => {
        setPaymentDate(e.target.value);
    };

    // useEffect(() => {
    //     const today = new Date();
    //     const formattedDate = today.toISOString().split('T')[0];
    //     setCurrentDate(formattedDate);
    // }, []);

    // #region Handlesubmit
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnLoading(true);

        let invoiceStatus = '';

        if ((Number(paidAmount) || 0) + (Number(INVObj?.PaidAmount) || 0) < totalAmount) {
            invoiceStatus = 'PARTIALLYPAID';
        }

        if ((Number(paidAmount) || 0) + (Number(INVObj?.PaidAmount) || 0) >= totalAmount) {
            invoiceStatus = 'PAID';
        }

        if (!paidAmount) {
            invoiceStatus = 'PENDING';
        }

        const requestPayload = {
            PaidDate: paymentDate,
            InvoiceStatus: invoiceStatus,
            TotalPaidAmount: (Number(paidAmount) || 0) + (Number(INVObj?.PaidAmount)),
            PaidAmount: (Number(paidAmount) || 0),
            POId: INVObj?.PurchaseId,
            PaymentTypeId: paymentType,
            CardNo: cardNo,
            MobileNo: mobile,
            CreatedBy: userDataSession.UserId
        };

        console.log(requestPayload, 'sending data to api');
    
        Axios.post(`${API_BASE_URL}${ADD_PAYMENTS}`, requestPayload)
        .then(response => {
            console.log(response.data, 'rrrrrrrr');

            if (response.data.result[0]['Status'] == 'Success') {
                setSubmitBtnLoading(false);

                // Show success message
                Swal.fire({
                    title: `Payment Added Successfully.`,
                    icon: "success",
                }).then((result) => {
                    if (result.isConfirmed || result.isDismissed) {
                        window.location.reload();
                    }
                });
            } else {
                setSubmitBtnLoading(false);

                Swal.fire({
                    title: "Error",
                    text: "Failed to Request Submit.",
                    icon: "error",
                });
            }
        })
            .catch(error => {
                setSubmitBtnLoading(false);
                console.error("Error:", error);
            });
    };
    
    const customStyles = {
        control: (provided) => ({
          ...provided,
          minHeight: "2rem",
          height: "2.4rem",
        }),
        // valueContainer: (provided) => ({
        //   ...provided,
        //   height: "1rem",
        //   padding: "0 6px",
        // }),
        // input: (provided) => ({
        //   ...provided,
        //   margin: "0",
        // }),
    };

    // console.log(INVObj)
 
    
    return (
        <div>
            {/* Add Payemnt */}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightInvPayment"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: "48%" }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Invoice Payment</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    {loading ?
                        <p className='text-center'>Loading...</p>
                    : 
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-3 col-md-3 col-sm-12">
                                    <div className="input-blocks add-product">
                                        <label>Supplier</label>
                                        <div className="row">
                                            <div className="col-lg-12 col-sm-12 col-12">
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    value={viewProducts[0]?.SupplierName}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-12">
                                    <div className="input-blocks add-product">
                                        <label>Store</label>
                                        <div className="row">
                                            <div className="col-lg-12 col-sm-12 col-12">
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    value={viewProducts[0]?.StoreName}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-12">
                                    <div className="input-blocks">
                                        <label>Paid Amount</label>
                                        <div className="input-groupicon ">
                                            <input
                                                type='text'
                                                className='form-control'
                                                value={INVObj?.PaidAmount}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-12">
                                    <div className="input-blocks">
                                        <label>Due Amount</label>
                                        <div className="input-groupicon ">
                                            <input
                                                type='text'
                                                className='form-control'
                                                value={(INVObj?.InvoiceAmount - INVObj?.PaidAmount).toFixed(2)}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-2 mt-2">
                                <div className="col-lg-12">
                                    <div className="modal-body-table">
                                        <div className="table-responsive" style={{ maxHeight: '20rem', overflowY: 'auto' }}>
                                            <table className="table  datanew">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Product</th>
                                                        <th>Quantity</th>
                                                        <th>Price</th>
                                                        <th>Units</th>
                                                        <th>Tax</th>
                                                        <th>Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {viewProducts.length !== 0 ? viewProducts.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.Productname}</td>
                                                            <td>{item.Quantity}</td>
                                                            <td>{item.UnitPrice}</td>
                                                            <td>{item.Units}</td>
                                                            <td>{item.CGSTRate}, {item.SGSTRate}</td>
                                                            <td>
                                                                {(
                                                                    ((item.Quantity || 0) * (item.UnitPrice || 0)) + 
                                                                    (((item.CGSTRate || 0) + (item.SGSTRate || 0)) / 100 * (item.Quantity || 0) * (item.UnitPrice || 0))
                                                                ).toFixed(2)}
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan="8" className="text-center">No Data available</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            <div className='d-flex justify-content-between mt-2 sticky-bottom'>
                                                <h5>Total Discount: <span className='fw-bold fs-5 text-primary'>{Number(INVObj?.DiscountAmount || 0).toFixed(2)}</span></h5>
                                                <h5>Total Tax: <span className='fw-bold text-primary fs-5'>{Number(taxAmount || 0).toFixed(2)}</span></h5>
                                                <h5>Total Amount: <span className='fw-bold text-primary fs-5'>{Number(totalAmount|| 0).toFixed(2)}</span></h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mt-2'>
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            <div className="input-blocks">
                                                <label>Date<span className="fw-bold text-danger">*</span></label>
                                                <div className="input-groupicon calender-input">
                                                    <input
                                                        type='date'
                                                        className='form-control'
                                                        value={paymentDate}
                                                        onChange={handlePaymentDateChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-3 col-md-3'>
                                            <label className='form-label'>Amount<span className="fw-bold text-danger">*</span></label>
                                            <input
                                                type='number'
                                                className='form-control'
                                                placeholder='Enter paying amount'
                                                onChange={handlePaidAmountChange}
                                                onWheel={(e) => e.target.blur(e)}
                                            />
                                        </div>
                                        <div className=' col-lg-3 col-md-3 form-group'>
                                            <label className='form-label'>Payment Type<span className="fw-bold text-danger">*</span></label>
                                            <Select
                                                className="select"
                                                id="categorySelect"
                                                onChange={handlePaymentTypeChange}
                                                options={paymentTypes?.map(ptypes => ({
                                                    value: ptypes.Id,
                                                    label: ptypes.Name
                                                }))}
                                                placeholder="Choose type"
                                                styles={customStyles}
                                            />
                                        </div>
                                        <div className='col-lg-3 col-md-3'>
                                            <label className='form-label'>Mobile Number</label>
                                            <input
                                                type='text'
                                                className='form-control'
                                                placeholder='Enter mobile no'
                                                onChange={(e) => {setMobile(e.target.value)}}
                                                maxLength={10}
                                            />
                                        </div>
                                        <div className='col-lg-3 col-md-3'>
                                            <label className='form-label'>Card Number</label>
                                            <input
                                                type='text'
                                                className='form-control'
                                                placeholder='Enter card no'
                                                onChange={(e) => {setCardNo(e.target.value)}}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-auto d-flex justify-content-end p-3">
                                <button
                                    type="button"
                                    className="btn btn-cancel me-2"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                >
                                    Cancel
                                </button>
                                <button className='btn btn-primary me-2' 
                                 disabled={submitBtnLoading}
                                >{submitBtnLoading ? 'Submitting...' : 'Submit'}</button>
                            </div>
                        </form> 
                    }
                </div>
            </div>
        </div>
    )
}

GenerateInvoicePayment.propTypes = {
    INVObj: PropTypes.object.isRequired,
};

export default GenerateInvoicePayment
